import qs from 'query-string';
import { useHistory } from 'react-router-dom';

import { routes } from 'lane-shared/config';
import { useAuth0Enabled } from 'lane-shared/hooks/auth0/useAuth0Enabled';
import { useFlag } from 'lane-shared/hooks';
import { FeatureFlag } from 'constants-flags';

import useAuthModal from 'hooks/useAuthModal';

export function useRestrictedAccessLogin() {
  const history = useHistory();
  const isAuth0Enabled = useAuth0Enabled();
  const isFixLegacyPromptEnabled = useFlag(
    FeatureFlag.FixLegacyPromptOnRestrictedAccessPage,
    false
  );
  const { showAuthModal } = useAuthModal({});

  return function onLoginClick() {
    if (isFixLegacyPromptEnabled && isAuth0Enabled) {
      history.push({
        pathname: routes.identifier,
        search: qs.stringify({
          contentPath: `${history.location.pathname}${history.location.search}`,
        }),
      });
    } else {
      showAuthModal();
    }
  };
}
